export const STORE = {
  List: '/pos/stores',
};
